
import { defineComponent } from "vue";

export default defineComponent({
    name: "Tooltip",
    props: {
        tooltipMessage: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            showTooltip: false,
        };
    },

    methods: {
        mouseOverHandler() {
            this.showTooltip = true;
        },

        mouseLeaveHandler() {
            const tooltipContainer = this.$refs
                .tooltipContainer as HTMLDivElement;
            tooltipContainer.style.transform = "scale(0, 0)";

            setTimeout(() => {
                this.showTooltip = false;
            }, 250);
        },
    },

    computed: {
        tooltipStyles() {
            const minWidth: number =
                this.tooltipMessage.length >= 65 ? 400 : 200;
            const left: number = Math.floor(minWidth - 100) * 0.5;

            return {
                minWidth: `${minWidth}%`,
                left: `-${left}%`,
            };
        },
    },
});
